import { inject, Injectable } from '@angular/core';

import { WidgetDataSource } from 'app/models';
import { AiInsightPayloadParams } from 'app/modules/widget/components/widget-expansion-panel/widget-ai-insights/services/point-selection/widget-ai-insights-point-selection.service';

import { AiInsightProperties, AiInsightStatus } from '../semantria-api/ai-insights.service';
import { MatchmakerParameters } from '../semantria-api/spote.service';
import { StorageAPIService } from '../storage-api.service';
import { TimezoneService } from '../../services/timezone.service';
import { urlFor } from './utils';

export interface AiInsightPayload {
  scene_id: string;
  properties: AiInsightProperties;
  scene_params?: MatchmakerParameters;
  buckets: MatchmakerParameters[];
}

export interface AsyncAiInsightResult {
  text: string;
  reasoningText: string;
}

export interface AsyncAiInsightResponse {
  jobId: string;
  batchId: string;
  batchItemId: string;
  evaluationId: string;
  insightId: string;
  insightProperties: AiInsightProperties;
  resultLanguageId: string;
  callbackUrl: string;
  status: AiInsightStatus;
  errors: string[];
  results: AsyncAiInsightResult[];
}

export interface AiInsightCreateResponse {
  prepResponse: AsyncAiInsightResponse[];
  completionTaskId: string;
  insightId: string;
  errorMessage: string;
}

@Injectable({
  providedIn: 'root',
})
export class AiInsightsDataprepService extends StorageAPIService {
  private timezoneService = inject(TimezoneService);

  generateInsight(
    projectId: string,
    widgetDataSource: WidgetDataSource,
    handlerId: string,
    parameters: AiInsightPayloadParams
  ) {
    const payload: AiInsightPayload = {
      scene_id: handlerId,
      ...parameters,
    };
    let urlPath = '';
    if (widgetDataSource.type === 'group') {
      const analysisGroupId = widgetDataSource.groupId;
      urlPath = `/analysis-groups/${analysisGroupId}/_create_insights`;
    } else {
      const collectionId = widgetDataSource.collectionName;
      const analysisName = widgetDataSource.analysisId;
      urlPath = `/collections/${collectionId}/analyses/${analysisName}/_create_insights`;
    }
    return this.post<AiInsightCreateResponse>(urlFor(urlPath, projectId), payload, undefined, {
      timezone: this.timezoneService.timezone,
    });
  }

  regenerateInsight(_id: string) {
    return new Promise<Partial<AiInsightCreateResponse>>((resolve) => {
      setTimeout(() => resolve({}), 1000);
    });
  }
}
